var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-skeleton', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('base-info', {
    attrs: {
      "data": _vm.detailData
    }
  }), _c('logs', {
    attrs: {
      "data": _vm.detailData
    }
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };